import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';


export const searchBuyerCreditNotes = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/adjustment-note/searchBuyerCreditNotes`, data);
        console.log("res", response)
        return await response.data;
    } catch (error) {
        console.log("searchBuyerCreditNotes - error", error)
        return handleApiError(error)
    }
}

export const searchSellerDebitNotes = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/adjustment-note/searchSellerDebitNotes`, data);
        console.log("searchSellerDebitNotes res", response)
        return await response.data;
    } catch (error) {
        console.log("searchSellerDebitNotes - error", error)
        return handleApiError(error)
    }
}

export const getAdjustmentNoteById = async (adjustmentNoteId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/adjustment-note/${adjustmentNoteId}`);
        return await response.data;
    } catch (error) {
        console.log("getAdjustmentNoteById - error", error)
        return handleApiError(error)
    }
}

export const insertBuyerCreditNote = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/adjustment-note/buyerCreditNote`, data);
        return await response.data;
    } catch (error) {
        console.log("insertCreditNote - error", error)
        return handleApiError(error)
    }
}

export const insertBuyerDebitNote = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/adjustment-note/buyerDebitNote`, data);
        return await response.data;
    } catch (error) {
        console.log("insertCreditNote - error", error)
        return handleApiError(error)
    }
}

export const insertDebitNote = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/adjustment-note/debitNote`, data);
        return await response.data;
    } catch (error) {
        console.log("insertCreditNote - error", error)
        return handleApiError(error)
    }
}

export const assignDocNoToAdjustmentNote = async (adjustmentNoteId) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/adjustment-note/assign-docno/${adjustmentNoteId}`);
        return await response.data;
    } catch (error) {
        console.log("assignDocNoToAdjustmentNote - error", error)
        return handleApiError(error)
    }
}

export const updateAdjustmentNote = async (adjustmentNoteId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/adjustment-note/update/${adjustmentNoteId}`, data);
        return await response.data;
    } catch (error) {
        console.log("updateAdjustmentNote - error", error)
        return handleApiError(error)
    }
}

export const updateAdjustmentNoteBookingStatus = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/adjustment-note/updateBookingStatus`, data);
        return await response.data;
    } catch (error) {
        console.log("updateAdjustmentNoteBookingStatus - error", error)
        return handleApiError(error)
    }
}

export const getSellerDebitNoteDocument = async (adjustmentNoteId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/adjustment-note/sellerDebitNote/${adjustmentNoteId}`);
        return await response.data;
    } catch (error) {
        console.log("getSellerDebitNoteDocument - error", error)
        return handleApiError(error)
    }
}

export const getBuyerCreditNoteDocument = async (adjustmentNoteId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/adjustment-note/buyerCreditNote/note/${adjustmentNoteId}`);
        return await response.data;
    } catch (error) {
        console.log("getBuyerCreditNoteDocument - error", error)
        return handleApiError(error)
    }
}

export const getBuyerCreditNotesByBuyerInvoiceIds = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/adjustment-note/creditnotes/buyerinvoiceids`, data);
        return await response.data.data;
    } catch (error) {
        console.log("getBuyerCreditNotesByBuyerInvoiceIds - error", error)
        return handleApiError(error)
    }
}

export const getAdjustmentNotesBySellerPIPunchIds = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/adjustment-note/get/sellerPIPunchIds`, data);
        return await response.data;
    } catch (error) {
        console.log("getAdjustmentNotesBySellerPIPunchIds - error", error)
    }
}

export const getAdjustmentNotesByBuyerInvoiceIds = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/adjustment-note/get/buyerInvoiceIds`, data);
        return await response.data;
    } catch (error) {
        console.log("getAdjustmentNotesByBuyerInvoiceIds - error", error)
    }
}

export const cancelAdjustmentNotes = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/adjustment-note/cancel-adjustment-note/${data.adjustmentNoteId}`, data);
        return await response.data;
    } catch (error) {
        console.log("cancelAdjustmentNotes - error", error)
        return handleApiError(error)
    }
}

export const approveAdjustmentNote = async (adjustmentNoteId) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/adjustment-note/approve/${adjustmentNoteId}`);
        return await response.data;
    } catch (error) {
        console.log("approveAdjustmentNote - error", error)
        return handleApiError(error)
    }
}

export const generateBuyerCreditNoteEInvoice = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/adjustment-note/creditNoteEinvoice`, data);
        return await response.data;
    } catch (error) {
        console.log("generateBuyerCreditNoteEInvoice - error", error)
        return handleApiError(error)
    }
}


export const cancelBuyerCreditNoteEInvoice = async (adjustmentNoteId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/adjustment-note/cancelBuyerCreditNote/${adjustmentNoteId}`, data);
        return await response.data;
    } catch (error) {
        console.log("cancelBuyerCreditNoteEInvoice - error", error)
        return handleApiError(error)
    }
}

export const getAdjustmentNoteByDocNo = async (docNo) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/adjustment-note/adjustment-note-by-doc-no/${docNo}`);
        return await response.data;
    } catch (error) {
        console.log("getAdjustmentNoteByDocNo - error", error)
        return handleApiError(error)
    }
}

export const searchSellerDebitNotesRaw = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/adjustment-note/seller-debit-notes/search`, data);
        console.log("searchSellerDebitNotesRaw", response.data)
        return await response.data;
    } catch (error) {
        console.log("searchSellerDebitNotesRaw - error", error)
        return handleApiError(error)
    }
}

export const getAdjustmenyNoteByLinkedDocNo = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/adjustment-note/adjustment-note-by-linked-doc-no`, data);
        return await response.data;
    } catch (error) {
        console.log("getApprovalInstancesByDocNos - error", error)
        return handleApiError(error)
    }
}

export const getAdjustmentNotes = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/adjustment-note/get-adjustment-note`, data);
        return await response.data;
    } catch (error) {
        console.log("getAdjustmentNotes - error", error)
        return handleApiError(error)
    }
}

export const updateVPAdjustedAmount = async (adjustmentNoteId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/adjustment-note/update-vp-adjusted-amount/${adjustmentNoteId}`, data);
        return await response.data;
    } catch (error) {
        console.log("updateVPAdjustedAmount - error", error)
        return handleApiError(error)
    }
}